var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"message-container",attrs:{"elevation":"1"}},[_c('v-icon',{attrs:{"size":"36","color":_vm.status ? 'success' : 'error'}},[_vm._v(" "+_vm._s(_vm.status ? 'check_circle' : 'error')+" ")]),_c('div',{staticClass:"message-text"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }